import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import '../css/style.css'; // Previously: './ServiceInformation.css';
import Logo from '../assets/logo.svg'; // Import SVG logoa
import ImageSlider from '../components/ImageSlider'; // Import komponente za slajder

const ServiceInformation = () => {
    const { slug } = useParams(); // Dohvati slug iz URL-a
    const [place, setPlace] = useState(null); // Podaci o smeštaju
    const [services, setServices] = useState([]); // Podaci za servise
    const [sliderImages, setSliderImages] = useState([]); // Slike za slajder
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Dohvati servise vezane za ovaj smeštaj
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/accommodations/${slug}/services`);
                setServices(response.data.services); // Postavi servise
                setPlace({ cover_image: response.data.cover_image }); // Postavi sliku

                // Dohvati slike za slajder
                const accommodationResponse = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/accommodations/${slug}`
                );
                const images = accommodationResponse.data.slider_images
                    ? accommodationResponse.data.slider_images
                        .split(';')
                        .map((img) => `${process.env.REACT_APP_BACKEND_URL}/${img}`)
                    : [];
                setSliderImages(images);

                setLoading(false);
            } catch (err) {
                console.error('Error fetching data:', err);
                setError('Failed to load data.');
                setLoading(false);
            }
        };

        fetchData();
    }, [slug]);

    if (loading) {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    fontFamily: 'Montserrat, sans-serif',
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                }}
            >
                <img
                    src={Logo} // Učitavanje SVG logoa
                    alt="Loading logo"
                    style={{ width: '150px', marginBottom: '20px' }}
                />
                <p style={{ fontSize: '20px', fontWeight: 'bold', margin: '0' }}>Loading...</p>
            </div>
        );
    }

    if (error) {
        return <p>{error}</p>;
    }

    if (!services.length) {
        return (
            <div>
                <div className="header-slider">
                    {sliderImages.length > 0 ? (
                        <ImageSlider images={sliderImages} />
                    ) : (
                        <div
                            className="header-image"
                            style={{
                                backgroundImage: `url(${place?.cover_image || '/images/noimage.jpg'})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                height: '300px',
                                width: '100vw',
                            }}
                        />
                    )}
                </div>
                <p>No services are available for this accommodation at the moment.</p>
            </div>
        );
    }

    return (
        <div className="service-information-page">
            <div className="header-slider">
                {sliderImages.length > 0 ? (
                    <ImageSlider images={sliderImages} />
                ) : (
                    <div
                        className="header-image"
                        style={{
                            backgroundImage: `url(${place?.cover_image || '/images/noimage.jpg'})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '300px',
                            width: '100vw',
                        }}
                    />
                )}
            </div>

            <div className="content-boxed">
                <div className="breadcrumb-container">
                    <p className="breadcrumb">
                        <Link to={`/accommodations/${slug}`} className="breadcrumb-link">Home</Link>
                        <span className="breadcrumb-divider"> &gt; </span>
                        <span className="current-page">Service Information</span>
                    </p>
                </div>

                <div className="service-list">
                    {services.map((service, index) => (
                        <div className="service-item" key={index}>
                            <h2>{service.category_name}</h2>
                            <p>{service.description}</p>
                            {service.phone && (
                                <p>
                                    <strong>Phone: </strong>
                                    <a href={`tel:${service.phone}`}> {service.phone}</a>
                                </p>
                            )}
                            {service.email && (
                                <p>
                                    <strong>Email: </strong>
                                    <a href={`mailto:${service.email}`}>{service.email}</a>
                                </p>
                            )}
                            {service.website && (
                                <p>
                                    <strong>Website: </strong>
                                    <a href={service.website} target="_blank" rel="noopener noreferrer">
                                        {service.website}
                                    </a>
                                </p>
                            )}
                            {service.working_hours && (
                                <p><strong>Working Hours:</strong> {service.working_hours}</p>
                            )}
                            <p><strong>Address:</strong> {service.address}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ServiceInformation;
